import { render, staticRenderFns } from "./BannerManage.vue?vue&type=template&id=a8e30e34&scoped=true"
import script from "./BannerManage.vue?vue&type=script&lang=js"
export * from "./BannerManage.vue?vue&type=script&lang=js"
import style0 from "./BannerManage.vue?vue&type=style&index=0&id=a8e30e34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e30e34",
  null
  
)

export default component.exports